// Header initializer used by pages that load the header component
(function(){
    // Format user display: prefer username if available, else local part of email
    function getDisplayName() {
        const userEmail = sessionStorage.getItem('tfx_email') || sessionStorage.getItem('userEmail') || localStorage.getItem('tfx_email') || localStorage.getItem('userEmail');
        const userId = sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
        if (!userEmail) return 'Usuario';
        try {
            // Prefer new storage keys, fallback to legacy
            const username = localStorage.getItem('tfx_username') || localStorage.getItem('userName') || localStorage.getItem('username');
            if (username) return username;
        } catch (e){}
        // default: part before @
        return userEmail.split('@')[0];
    }

    function setUserDisplays() {
        const displays = ['currentUserDisplay', 'currentUserDisplayMobile'];
        const name = hasValidSession() ? getDisplayName() : 'Usuario';
        displays.forEach(id => {
            const el = document.getElementById(id);
            if (el) el.textContent = name.toUpperCase();
        });
    }

    function hasValidSession() {
        const isDemo = localStorage.getItem('demo_mode') === 'true';
        if (isDemo) return true;

        try {
            if (localStorage.getItem('_sessionExpired') === 'true') {
                return false;
            }
        } catch (e) {}

        try {
            if (window.SessionValidator && typeof SessionValidator.isClientSessionValid === 'function') {
                return SessionValidator.isClientSessionValid();
            }
        } catch (e) {}

        const token = sessionStorage.getItem('tfx_authToken') || sessionStorage.getItem('tfx_token') ||
                      sessionStorage.getItem('userToken') || sessionStorage.getItem('authToken') ||
                      localStorage.getItem('tfx_authToken') || localStorage.getItem('tfx_token') ||
                      localStorage.getItem('userToken') || localStorage.getItem('authToken');
        const userId = sessionStorage.getItem('tfx_userId') || sessionStorage.getItem('currentUserId') ||
                       localStorage.getItem('tfx_userId') || localStorage.getItem('currentUserId');

        return !!(token && userId);
    }

    function cleanupStaleIdentity() {
        try {
            const keys = [
                'tfx_token', 'tfx_authToken', 'tfx_email', 'tfx_userId', 'tfx_username',
                'tfx_plan', 'tfx_userType', 'tfx_expiresAt', 'tfx_sessionId', 'tfx_paypalSubId',
                'userToken', 'authToken', 'currentUserId', 'userEmail', 'userName',
                'userPlan', 'userType', 'expiresAt', 'stripeCustomerId', 'paypalSubscriptionId', 'userCreatedAt',
                'username'
            ];
            keys.forEach(key => {
                localStorage.removeItem(key);
                sessionStorage.removeItem(key);
            });
        } catch (e) {}
    }

    function setActiveTabByPath() {
        const path = window.location.pathname || '';
        const href = window.location.href || '';
        const filename = (path.split('/').pop() || href.split('/').pop() || '').toLowerCase();

        document.querySelectorAll('.nav-tab').forEach(tab => tab.classList.remove('active'));

        if (path === '/' || path === '/dashboard' || path.includes('dashboard') || filename === '' || filename.includes('index')) {
            document.getElementById('nav-home')?.classList.add('active');
        } else if (path === '/journal' || path.includes('journal') || filename.includes('journal')) {
            document.getElementById('nav-journal')?.classList.add('active');
        } else if (path === '/accounts' || path.includes('accounts') || filename.includes('accounts')) {
            document.getElementById('nav-accounts')?.classList.add('active');
            document.getElementById('nav-accounts-mobile')?.classList.add('active');
        }
    }

    function updateAdminVisibility() {
        const userType = (localStorage.getItem('userType') || '').toLowerCase().trim();
        const userPlan = (localStorage.getItem('userPlan') || 'free').toLowerCase().trim();
        
        // ?? SECURITY: Solo usuarios con rol 'admin' pueden ver el bot�n
        // Un usuario PRO/UNLIMITED NO es admin
        const isAdmin = (userType === 'admin');
        
        // Debug solo si hay inconsistencia (comentar en producci�n)
        if (userType && userType !== 'user' && userType !== 'admin') {

        }
        
        const adminButtons = document.querySelectorAll('.admin-only');
        adminButtons.forEach(btn => {
            if (isAdmin) {
                btn.style.cssText = 'display: inline-flex !important; pointer-events: auto !important;';
            } else {
                btn.style.cssText = 'display: none !important; pointer-events: none !important;';
            }
        });
        
        // Mostrar/ocultar bot�n Admin en dropdown menu
        const adminMenuBtn = document.getElementById('adminMenuBtn');
        if (adminMenuBtn) {
            adminMenuBtn.style.display = isAdmin ? 'flex' : 'none';
        }
    }

    // ?? Ocultar bot�n de Gesti�n para usuarios FREE (PRO y UNLIMITED tienen acceso)
    function updateAccountsVisibility() {
        const readValue = (key) => {
            try {
                return sessionStorage.getItem(key) || localStorage.getItem(key) || '';
            } catch (e) {
                return '';
            }
        };

        const userType = (readValue('tfx_userType') || readValue('userType') || 'user').toLowerCase().trim();
        const userPlan = (readValue('tfx_plan') || readValue('userPlan') || 'free').toLowerCase().trim();
        const accountsBtn = document.getElementById('nav-accounts');
        const accountsBtnMobile = document.getElementById('nav-accounts-mobile');
        const desktopGestionLink = document.getElementById('desktopGestionLink');
        const mobileGestionLink = document.getElementById('mobileGestionLink');
        
        // Mostrar para PRO, UNLIMITED o admin (solo FREE no tiene acceso)
        const hasAccess = userType === 'admin' || userPlan === 'pro' || userPlan === 'unlimited';
        
        if (accountsBtn) {
            accountsBtn.style.display = hasAccess ? 'inline-flex' : 'none';
        }
        if (accountsBtnMobile) {
            accountsBtnMobile.style.display = hasAccess ? 'inline-flex' : 'none';
        }
        if (desktopGestionLink) {
            desktopGestionLink.style.display = hasAccess ? 'inline-block' : 'none';
        }
        if (mobileGestionLink) {
            mobileGestionLink.style.display = hasAccess ? 'inline-block' : 'none';
        }
    }

    function initHeaderComponent() {
        try {
            // Track recent user activity timestamp so other modules can decide
            // whether to auto-open intrusive UI (modals) when the user is actually
            // interacting with the page. Updated on mouse/keyboard/touch/click.
            try {
                window._lastUserActivity = Date.now();
                const activityEvents = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'click'];
                const activityHandler = () => { try { window._lastUserActivity = Date.now(); } catch (e) {} };
                activityEvents.forEach(ev => window.addEventListener(ev, activityHandler, { passive: true }));
            } catch (e) { /* ignore */ }

            if (!hasValidSession()) {
                cleanupStaleIdentity();
            }

            setUserDisplays();

            try {
                if (window.SessionValidator && typeof SessionValidator.validateWithServer === 'function') {
                    SessionValidator.validateWithServer().then((isValid) => {
                        if (!isValid) {
                            cleanupStaleIdentity();
                            setUserDisplays();
                        }
                    });
                }
            } catch (e) {}
            setActiveTabByPath();
            updateAdminVisibility();
            updateAccountsVisibility();
            
            // ?? Re-verificar despu�s de un momento para p�ginas que cargan lentamente
            setTimeout(() => {
                try { 
                    updateAdminVisibility(); 
                    updateAccountsVisibility(); 
                } catch (err) {}
            }, 100);
            
            // ?? Escuchar cambios en localStorage para actualizar visibilidad del bot�n admin
            window.addEventListener('storage', function(e) {
                if (e.key === 'userType' || e.key === 'userPlan') {
                    try { updateAdminVisibility(); } catch (err) {}
                    try { updateAccountsVisibility(); } catch (err) {}
                }
            });

            // Escuchar actualizaciones internas de userType (mismo tab)
            window.addEventListener('userTypeUpdated', function() {
                try { updateAdminVisibility(); } catch (err) {}
                try { updateAccountsVisibility(); } catch (err) {}
            });
            
            // Mejorado: manejo del men� m�vil
            const menuBtn = document.getElementById('mobileMenuBtn');
            const mobileNav = document.getElementById('mobileNav');

            if (menuBtn && mobileNav) {
                menuBtn.addEventListener('click', function() {
                    const isOpen = mobileNav.classList.contains('show');
                    if (isOpen) {
                        mobileNav.classList.remove('show');
                        menuBtn.classList.remove('active');
                    } else {
                        mobileNav.classList.add('show');
                        menuBtn.classList.add('active');
                    }
                });

                // Cerrar el men� al hacer clic en un enlace
                mobileNav.addEventListener('click', function(e) {
                    const link = e.target.closest('.nav-tab');
                    if (!link) return;

                    // Prevenir navegaci�n para acciones especiales
                    if (link.dataset.action) {
                        e.preventDefault();
                        mobileNav.classList.remove('show');
                        menuBtn.classList.remove('active');

                        // Ejecutar la acci�n correspondiente
                        if (link.dataset.action === 'admin') {
                            if (typeof showAdminAuth === 'function') showAdminAuth();
                        } else if (link.dataset.action === 'user') {
                            if (typeof showUserInfo === 'function') showUserInfo();
                        }
                    } else {
                        mobileNav.classList.remove('show');
                        menuBtn.classList.remove('active');
                    }
                });
            }

            // ? SOLO VINCULAR BOTONES DE LOGOUT, NO SOBRESCRIBIR LA FUNCI�N
            try {
                document.querySelectorAll('.logout-btn').forEach(btn => {
                    // ?? No tocar botones con funcionalidad propia
                    if (btn.id === 'upgradePlanBtn' || btn.id === 'adminAccessBtn') return;
                    
                    btn.removeAttribute('onclick');
                    btn.addEventListener('click', function(e){ 
                        e.preventDefault(); 
                        if (window.logoutUser && typeof window.logoutUser === 'function') {
                            window.logoutUser(); 
                        } 
                    });
                });
            } catch (e) {}

            // Close floating user panel when clicking outside
            document.addEventListener('click', function(evt) {
                try {
                    const modal = document.getElementById('userInfoModal');
                    const userBtn = document.querySelector('.user-info-btn');
                    if (!modal) return;
                    if (!modal.classList.contains('user-panel')) return;

                    const panelContent = modal.querySelector('.modal-content');
                    const isClickInsidePanel = panelContent && panelContent.contains(evt.target);
                    const isClickOnUserBtn = userBtn && userBtn.contains(evt.target);

                    if (!isClickInsidePanel && !isClickOnUserBtn) {
                        try { 
                            modal.classList.remove('show');
                            try { modal.style.display = 'none'; } catch (e) {}
                            modal.classList.remove('user-panel'); 
                            modal.setAttribute('aria-hidden', 'true');
                        } catch (e) {}
                    }
                } catch (e) {}
            });
            
            // Robust delegation for mobile menu clicks
            document.addEventListener('click', function(evt) {
                try {
                    const btn = evt.target.closest && evt.target.closest('.mobile-menu-btn');
                    if (btn) {
                        toggleMobileMenu();
                    }
                } catch (e) {}
            });

            // Attach a resilient admin auth form handler so the modal works even
            // if module scripts haven't loaded yet. This posts to /api/admin-login
            // (or to window.WORKER_URL if available) and shows a clear error on failure.
            try {
                const adminForm = document.getElementById('adminAuthForm');
                if (adminForm) {
                    adminForm.addEventListener('submit', async function (e) {
                        e.preventDefault();
                        const pwdEl = document.getElementById('adminPassword');
                        const errorEl = document.getElementById('adminAuthError');
                        if (errorEl) { errorEl.style.display = 'none'; errorEl.textContent = ''; }
                        if (!pwdEl) return;
                        const password = pwdEl.value || '';
                        if (!password.trim()) {
                            if (errorEl) { errorEl.textContent = 'Introduce la contraseña.'; errorEl.style.display = 'block'; }
                            return;
                        }

                        // determine endpoint
                        const base = (typeof window !== 'undefined' && window.WORKER_URL) ? (window.WORKER_URL.replace(/\/$/, '')) : '';
                        const url = (base || '') + '/api/admin-login';

                        // UI: disable submit
                        const submitBtn = adminForm.querySelector('button[type="submit"]');
                        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Verificando...'; }
                        try {
                            const res = await fetch(url, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ password })
                            });
                            const data = await res.json().catch(() => ({}));
                            if (!res.ok) {
                                const msg = data && data.error ? data.error : (data.message || 'Error en autenticaci�n');
                                if (errorEl) { errorEl.textContent = msg; errorEl.style.display = 'block'; }
                                try { if (window.showAlert) window.showAlert('Error de Autenticacion', msg, 'error'); } catch (e) {}
                                return;
                            }

                            // success: expect token in data.token
                            const token = data && (data.token || data.access_token || data.admin_token);
                            if (!token) {
                                const msg = 'Respuesta inesperada del servidor.';
                                if (errorEl) { errorEl.textContent = msg; errorEl.style.display = 'block'; }
                                try { if (window.showAlert) window.showAlert('Error del Servidor', msg, 'error'); } catch (e) {}
                                return;
                            }

                            // store in-memory, show success and update UI
                            window._adminToken = token;
                            try { sessionStorage.setItem('dbUserType', 'admin'); } catch (e) {}
                            // update header buttons visibility
                            try { updateAdminVisibility(); } catch (e) {}
                            // close auth modal
                            try { closeAdminAuthModal(); } catch (e) {}
                            
                            // Open admin panel
                            try {
                                const adminModal = document.getElementById('adminModal');
                                if (adminModal) {
                                    adminModal.classList.add('show');
                                    adminModal.style.display = 'flex';
                                    adminModal.setAttribute('aria-hidden', 'false');
                                }
                                // Start admin session timer
                                if (window.startAdminSession) {
                                    window.startAdminSession();
                                }
                                // Initialize admin panel data
                                if (window.initAdminPanel) {
                                    window.initAdminPanel();
                                }
                            } catch (e) {

                            }
        
                        } catch (err) {
                            const msg = 'No se pudo contactar al servidor.';
                            const errorEl2 = document.getElementById('adminAuthError');
                            if (errorEl2) { errorEl2.textContent = msg; errorEl2.style.display = 'block'; }
                            try { if (window.showAlert) window.showAlert('Error de Conexion', msg, 'error'); } catch (e) {}
                        } finally {
                            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Entrar'; }
                        }
                    });
                }
            } catch (e) {}
        } catch (e) {}
    }

    // mobile toggle helper
    function toggleMobileMenu() {
        const mobileNav = document.getElementById('mobileNav');
        const menuBtn = document.querySelector('.mobile-menu-btn');
        if (!mobileNav || !menuBtn) return;
        mobileNav.classList.toggle('show');
        menuBtn.classList.toggle('active');
    }

    // expose globally
    window.initHeaderComponent = initHeaderComponent;
    window.toggleMobileMenu = toggleMobileMenu;
    // Proporciona fallback global para modal de admin
    // P�ginas que cargan header antes de scripts de m�dulo pueden abrir el modal v�a onclick
    if (!window.showAdminAuth) {
        window.showAdminAuth = function({ force = false } = {}) {
            try {
                // ?? SEGURIDAD: Prevenir mostrar admin auth para usuarios no-admin
                const hasAdminToken = (typeof window !== 'undefined' && !!window._adminToken);
                const isDbAdmin = (typeof window !== 'undefined' && sessionStorage.getItem('dbUserType') === 'admin');
                const isLocalAdmin = (typeof window !== 'undefined' && localStorage.getItem('userType') === 'admin');
                
                // Solo mostrar modal de admin si el usuario tiene indicaci�n de admin
                if (!hasAdminToken && !isDbAdmin && !isLocalAdmin) {
                    // Usuario no es admin, no mostrar el modal
                    return;
                }

                // Guard: evitar abrir el modal de admin autom�ticamente durante carga
                const last = (window && window._lastUserActivity) ? Number(window._lastUserActivity) : 0;
                const idleMs = Date.now() - last;
                if (!force && last && idleMs > 10000) {
                    try { if (window.showAlert) window.showAlert('Panel Admin', 'Pulsa Admin para abrir el panel.', 'info', 3000); } catch(e){}
                    return;
                }

                const modal = document.getElementById('adminAuthModal');
                if (modal) {
                    modal.classList.add('show');
                    modal.setAttribute('aria-hidden', 'false');
                }
            } catch (e) {}
        };
    }
    // Cierre seguro del modal - asegurar que siempre se cierra correctamente
    if (!window.closeAdminAuthModal) {
        window.closeAdminAuthModal = function() {
            try {
                const modal = document.getElementById('adminAuthModal');
                if (modal) {
                    modal.classList.remove('show');
                    modal.setAttribute('aria-hidden', 'true');
                }
                const pwd = document.getElementById('adminPassword');
                if (pwd) pwd.value = '';
                const err = document.getElementById('adminAuthError');
                if (err) { err.style.display = 'none'; err.textContent = ''; }
            } catch (e) {}
        };
    }

    // Asegurar que el modal NO tiene la clase show por defecto
    document.addEventListener('DOMContentLoaded', () => {
        const adminAuthModal = document.getElementById('adminAuthModal');
        if (adminAuthModal) {
            adminAuthModal.classList.remove('show');
            adminAuthModal.setAttribute('aria-hidden', 'true');
        }
    });

    // Extra fallbacks: ensure the full admin panel (adminModal) can be closed
    // even if other bindings fail, and allow Escape to close admin modals.
    try {
        document.addEventListener('DOMContentLoaded', () => {
            const adminCloseBtn = document.getElementById('adminClose');
            if (adminCloseBtn) {
                adminCloseBtn.addEventListener('click', () => {
                    const modal = document.getElementById('adminModal');
                    if (modal) {
                        modal.classList.remove('show');
                        try { modal.style.display = 'none'; } catch (e) {}
                        modal.setAttribute('aria-hidden', 'true');
                    }
                });
            }

            // Escape key closes admin/auth modals to recover from stuck state
            window.addEventListener('keydown', (ev) => {
                if (ev.key === 'Escape' || ev.key === 'Esc') {
                    try {
                        ['adminModal','adminAuthModal','userInfoModal','authModal'].forEach(id => {
                            const m = document.getElementById(id);
                            if (m && (m.classList.contains('show') || m.style.display === 'flex')) {
                                m.classList.remove('show');
                                try { m.style.display = 'none'; } catch (e) {}
                                m.setAttribute('aria-hidden', 'true');
                            }
                        });
                    } catch (e) { /* ignore */ }
                }
            });
        });
    } catch (e) { /* ignore */ }
    
    // Ejecutar cuando el DOM está listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initHeaderComponent);
    } else {
        initHeaderComponent();
    }
    
    // ?? Exportar funciones para uso global
    if (typeof window !== 'undefined') {
        window.updateAccountsVisibility = updateAccountsVisibility;
        window.updateAdminVisibility = updateAdminVisibility;
    }
})();
